import React, { useState } from "react";
import {
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
  MDBRow,
  MDBCol,
  Fa
} from "mdbreact";

const FilterDropdown = ({ options, theme = "default", onApply = () => {} , toggleStyle = {}, width, customClassName }) => {
  const [selectedFilters, setSelectedFilters] = useState(options[0]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  var I18n = require("react-redux-i18n").I18n;

  const handleCheckboxChange = (filter) => {
    if (selectedFilters === filter) return; // Prevent unselecting the last one
    setSelectedFilters(filter);
  };

  const handleGoClick = () => {
    onApply(selectedFilters ? [selectedFilters] : []);
  };

  return (
    <MDBDropdown className="widget-filter-icon-container">
      <MDBDropdownToggle tag="div" style={{ display: "inline", cursor: "pointer", ...toggleStyle }}>
        <Fa icon="filter" className="widget-filter-icon" />
      </MDBDropdownToggle>

      <MDBDropdownMenu
        tag="div"
        className={`${customClassName} widgetTransform`}
       style={{ width: width ? width :"166px" }}
      >
        {options.map((option, idx) => {
          const isSelected = selectedFilters?.includes(option);
          const isHovered = hoveredIndex === idx;
          const bgColor = isSelected || isHovered ? "#DEEBFF" : "transparent";

          return (
            <MDBDropdownItem
              key={idx}
              toggle={false}
              tag="div"
              onClick={() => handleCheckboxChange(option)}
              style={{
                padding: "10px 15px",
                cursor: "pointer",
                userSelect: "none",
                transition: "background-color 0.2s ease",
              }}
            >
              <MDBRow>
                <MDBCol size="2">
                  <input
                    type="checkbox"
                    checked={selectedFilters === option}
                    readOnly
                    style={{ cursor: "pointer" }}
                  />
                </MDBCol>
                <MDBCol>
                  <span style={{fontSize: "14px" }}>{option}</span>
                </MDBCol>
              </MDBRow>
            </MDBDropdownItem>
          );
        })}

        {/* Go Button */}
        <MDBDropdownItem toggle={true} tag="div">
          <MDBRow style={{ paddingLeft: "50px", paddingTop:"5px" }}>
            <MDBCol>
              <button
                className={"filter-button-NAS filter-button-" + theme}
                onClick={handleGoClick}
                style={{
                  backgroundColor: "#E50000",
                  cursor: "pointer",
                }}
              >
              {I18n.t('dashboard.go')}
              </button>
            </MDBCol>
          </MDBRow>
        </MDBDropdownItem>
      </MDBDropdownMenu>
    </MDBDropdown>
  );
};

export default FilterDropdown;
